import { useState } from 'react'
import { isEmpty } from 'lodash-es'

import { EMPTY_STRING } from '../../../constants/common'
import { InputField } from '../../Input'
import {
  SubMenuAccordionButton,
  SubMenuAvailableItemsSection,
  SubMenuFoldersSection,
  SubMenuList,
} from '../../SubMenu'
import { Container } from '../Container'

import { FOLDERS, ITEMS_LIST } from './SubMenu.mock'

import * as styles from './SubMenu.module.css'

import SearchIcon from '../../../icons/search.svg'

function SubMenu() {
  const [value, setValue] = useState(EMPTY_STRING)
  const [filterList, setFilterList] = useState([...ITEMS_LIST])
  const [selected, setSelected] = useState(ITEMS_LIST[2])

  const keys = {
    activeKey: 'active',
    countKey: 'unread',
    selectedKey: 'id',
    titleKey: 'email',
  }

  function isNeedReconnect(item) {
    return item.status === 'need_reconnect'
  }

  function getSection(type) {
    const items = filterList.filter(i => i.type === type)

    if (items.length === 0) {
      return {}
    }

    let count = 0

    items.forEach(i => {
      count = i.unread ? count + i.unread : count
    })

    return {
      accordionTitle: type,
      count,
      initOpen: !!items.find(
        i => i[keys.selectedKey] === selected[keys.selectedKey]
      ),
      items,
    }
  }

  const sections = [
    { ...getSection('type1') },
    { ...getSection('type2') },
    { ...getSection('type3') },
    { ...getSection('more') },
  ].filter(value => !isEmpty(value))

  const listItemsOptions = {
    ...keys,
    isNeedReconnect,
    items: sections,
    selected: selected,
    onClick: item => setSelected(item),
    onReconnect: () => console.log('reconnect'),
  }

  const foldersProps = {
    apiKeys: { label: 'title', value: 'name' },
    counts: { [FOLDERS[0].name]: 5 },
    isActive: item => item.name === '2',
    items: FOLDERS,
    selectedTitle: selected[keys.titleKey],
    onClickItem: id => console.log(id),
  }

  function handleChangeSearch({ target: { value } }) {
    setValue(value)
    setFilterList(
      value
        ? ITEMS_LIST.filter(({ email }) => email.includes(value))
        : [...ITEMS_LIST]
    )
  }

  function handleClearSearch() {
    setValue(EMPTY_STRING)
    setFilterList([...ITEMS_LIST])
  }

  return (
    <>
      <Container label='AccordionButton short and long name with count 5, 0, 1000'>
        <div className={styles.wrapperBtn}>
          <SubMenuAccordionButton accordionTitle='type 1' count={5} />
        </div>
        <div className={styles.wrapperBtn}>
          <SubMenuAccordionButton accordionTitle='type 2 with long name' />
        </div>
        <div className={styles.wrapperBtn}>
          <SubMenuAccordionButton
            accordionTitle='type 2 with long name'
            count={1000}
          />
        </div>
      </Container>
      <Container label='Available items section'>
        <div className={styles.wrapper}>
          <SubMenuAvailableItemsSection {...listItemsOptions} />
        </div>
      </Container>
      <Container label='Available items section with search'>
        <div className={styles.wrapper}>
          <InputField
            afterIconProps={{ Icon: SearchIcon }}
            height={32}
            placeholder='Search...'
            value={value}
            wrapperClassName={styles.input}
            onChange={handleChangeSearch}
            onClear={handleClearSearch}
          />
          <SubMenuAvailableItemsSection {...listItemsOptions} />
        </div>
      </Container>
      <Container label='Sub Menu component'>
        <div className={styles.wrapperBtn}>
          <SubMenuList {...foldersProps} />
        </div>
      </Container>
      <Container label='Sum menu folders section'>
        <div className={styles.wrapper}>
          <SubMenuFoldersSection {...foldersProps} />
        </div>
      </Container>
    </>
  )
}

export default SubMenu
